import Bowser from 'bowser';

export function isMobileDevice () {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const platform = browser.getPlatformType();

  // Bowser considers tablets as mobile, but we might want to distinguish
  // For this use case, we'll consider mobile and tablet as mobile
  return platform === 'mobile' || platform === 'tablet';
}
